(() => {
  if (window.__novariaCartConfigLoaded) return;
  window.__novariaCartConfigLoaded = true;

  const clp = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
  const bool = (value) => value === 'true';
  let applyFrame = 0;

  function config() {
    return document.getElementById('NovariaCartConfig');
  }

  function mercadoPagoMarkup(iconUrl, extraClass = '') {
    if (!iconUrl) return '';
    return `
      <span class="novaria-payment-badge novaria-payment-badge--mercado-pago ${extraClass}" aria-label="Mercado Pago">
        <img class="novaria-payment-brand--mp-icon" src="${iconUrl}" alt="" aria-hidden="true">
      </span>`;
  }

  function cartPaymentMarkup(iconUrl) {
    return `
      <span class="novaria-payment-badge" role="listitem" aria-label="Visa"><span class="novaria-payment-brand--visa" aria-hidden="true">VISA</span></span>
      <span class="novaria-payment-badge" role="listitem" aria-label="Mastercard"><span class="novaria-payment-brand--mastercard" aria-hidden="true"></span></span>
      <span class="novaria-payment-listitem" role="listitem">${mercadoPagoMarkup(iconUrl)}</span>`;
  }

  function patchStaticCopy(root, cfg) {
    const heading = root.querySelector('.novaria-cart__heading');
    if (heading && cfg.dataset.heading && heading.textContent !== cfg.dataset.heading) heading.textContent = cfg.dataset.heading;

    const checkoutLabel = root.querySelector('.novaria-cart-checkout span:first-child');
    if (checkoutLabel && cfg.dataset.checkoutLabel && checkoutLabel.textContent !== cfg.dataset.checkoutLabel) checkoutLabel.textContent = cfg.dataset.checkoutLabel;

    const showSavings = bool(cfg.dataset.showSavings);
    root.querySelectorAll('.novaria-cart-item__saving, .novaria-cart-summary__row--saving').forEach((el) => { el.hidden = !showSavings; });

    const trust = root.querySelectorAll('.novaria-cart-trust > span');
    [cfg.dataset.trust1, cfg.dataset.trust2, cfg.dataset.trust3].forEach((text, index) => {
      const item = trust[index];
      if (!item || !text) return;
      const svg = item.querySelector('svg');
      let textNode = [...item.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());
      if (!textNode && svg) {
        textNode = document.createTextNode(text);
        item.append(textNode);
      } else if (textNode && textNode.nodeValue !== text) {
        textNode.nodeValue = text;
      }
    });
  }

  function patchCartPayments(root, cfg) {
    root.querySelectorAll('.novaria-cart-tax-note, .tax-note').forEach((note) => note.remove());

    const existing = root.querySelector('[data-novaria-payment-row]');
    if (!bool(cfg.dataset.showPaymentLogos)) {
      if (existing) existing.remove();
      return;
    }

    const checkout = root.querySelector('.novaria-cart-checkout');
    if (!checkout) return;

    const iconUrl = cfg.dataset.mercadoPagoIcon || '';
    if (existing && existing.dataset.mercadoPagoIcon === iconUrl) return;
    if (existing) existing.remove();

    const row = document.createElement('div');
    row.className = 'novaria-payment-row';
    row.dataset.novariaPaymentRow = '';
    row.dataset.mercadoPagoIcon = iconUrl;
    row.setAttribute('role', 'list');
    row.setAttribute('aria-label', 'Medios de pago aceptados');
    row.innerHTML = cartPaymentMarkup(iconUrl);
    checkout.insertAdjacentElement('afterend', row);
  }

  function removeShopifyPoweredBy() {
    document.querySelectorAll('.footer__copyright .copyright__content').forEach((item) => {
      const link = item.querySelector('a[href*="shopify.com"]');
      if (link) item.remove();
    });
  }

  function patchFooter(cfg) {
    removeShopifyPoweredBy();

    const list = document.querySelector('.footer__payment .list-payment');
    const existing = document.querySelector('[data-novaria-mercado-pago-footer]');
    const shouldShow = bool(cfg.dataset.showMercadoPagoFooter);
    const iconUrl = cfg.dataset.mercadoPagoIcon || '';

    if (!shouldShow || !list || !iconUrl) {
      if (existing) existing.remove();
      return;
    }

    const item = existing || document.createElement('li');
    item.className = 'list-payment__item novaria-mercado-pago-item';
    item.dataset.novariaMercadoPagoFooter = '';
    item.dataset.mercadoPagoIcon = iconUrl;
    item.setAttribute('aria-label', 'Mercado Pago');

    const currentImage = item.querySelector('.novaria-mercado-pago-footer__icon');
    if (!currentImage || currentImage.getAttribute('src') !== iconUrl || item.textContent.trim()) {
      item.innerHTML = `<img class="novaria-mercado-pago-footer__icon" src="${iconUrl}" alt="" aria-hidden="true">`;
    }
    if (!existing) list.append(item);
  }

  function patchRecommendation(root, cfg) {
    const existing = root.querySelector('[data-novaria-js-recommendation]');
    const shouldShow = bool(cfg.dataset.showRecommendation) && cfg.dataset.productTitle && cfg.dataset.productUrl;
    if (!shouldShow) {
      if (existing) existing.remove();
      return;
    }
    if (existing && existing.dataset.productUrl === cfg.dataset.productUrl && existing.dataset.productTitle === cfg.dataset.productTitle) return;
    if (existing) existing.remove();

    const items = root.querySelector('.novaria-cart-items');
    if (!items) return;

    const block = document.createElement('div');
    block.className = 'novaria-cart-recommendation';
    block.dataset.novariaJsRecommendation = '';
    block.dataset.productUrl = cfg.dataset.productUrl;
    block.dataset.productTitle = cfg.dataset.productTitle;

    const eyebrow = document.createElement('p');
    eyebrow.className = 'novaria-cart-recommendation__eyebrow';
    eyebrow.textContent = cfg.dataset.recommendationTitle || 'También te puede gustar';

    const link = document.createElement('a');
    link.className = 'novaria-cart-recommendation__card';
    link.href = cfg.dataset.productUrl;

    if (cfg.dataset.productImage) {
      const image = document.createElement('img');
      image.src = cfg.dataset.productImage;
      image.alt = cfg.dataset.productImageAlt || cfg.dataset.productTitle;
      image.loading = 'lazy';
      link.append(image);
    }

    const copy = document.createElement('span');
    copy.className = 'novaria-cart-recommendation__copy';
    const title = document.createElement('strong');
    title.textContent = cfg.dataset.productTitle;
    const price = document.createElement('span');
    price.textContent = cfg.dataset.productPrice || '';
    copy.append(title, price);

    const arrow = document.createElement('span');
    arrow.className = 'novaria-cart-recommendation__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';

    link.append(copy, arrow);
    block.append(eyebrow, link);
    items.insertAdjacentElement('afterend', block);
  }

  async function patchShipping(root, cfg) {
    const reward = root.querySelector('.novaria-cart-reward');
    if (!reward) return;
    const showShipping = bool(cfg.dataset.showShipping);
    reward.hidden = !showShipping;
    if (!showShipping) return;

    let cart;
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      cart = await response.json();
    } catch (_) {
      return;
    }

    if (!root.isConnected || config() !== cfg) return;

    const thresholdPesos = Math.max(0, Number(cfg.dataset.freeShippingThreshold || 0));
    const thresholdCents = thresholdPesos * 100;
    const totalCents = Number(cart.total_price || 0);
    const unlocked = thresholdCents <= 0 || totalCents >= thresholdCents;
    const remaining = Math.max(0, thresholdCents - totalCents);
    const progress = thresholdCents <= 0 ? 100 : Math.min(100, Math.round((totalCents / thresholdCents) * 100));

    reward.classList.toggle('is-unlocked', unlocked);
    const text = reward.querySelector('.novaria-cart-reward__text');
    const check = reward.querySelector('.novaria-cart-reward__check');
    const fill = reward.querySelector('.novaria-cart-progress__fill');

    if (text) {
      const nextText = unlocked
        ? (cfg.dataset.freeShippingUnlocked || '¡Tienes envío gratis a todo Chile!')
        : (cfg.dataset.freeShippingRemaining || 'Te faltan [monto] para envío gratis').replace('[monto]', clp.format(remaining / 100));
      if (text.textContent !== nextText) text.textContent = nextText;
    }
    if (check) check.hidden = !unlocked;
    if (fill) fill.style.setProperty('--progress', `${progress}%`);
  }

  function apply() {
    const cfg = config();
    if (!cfg) return;

    patchFooter(cfg);

    const root = document.getElementById('CartDrawer');
    if (!root) return;
    patchStaticCopy(root, cfg);
    patchCartPayments(root, cfg);
    patchRecommendation(root, cfg);
    patchShipping(root, cfg);
  }

  function scheduleApply() {
    if (applyFrame) cancelAnimationFrame(applyFrame);
    applyFrame = requestAnimationFrame(() => {
      applyFrame = 0;
      apply();
    });
  }

  function observeDrawer() {
    const root = document.getElementById('CartDrawer');
    if (!root || root.dataset.novariaObserved === 'true') return;
    root.dataset.novariaObserved = 'true';
    const observer = new MutationObserver(scheduleApply);
    observer.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    observeDrawer();
    scheduleApply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
